<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 减重小程序端-社区排行榜
-->

<template>
  <div class="page-main">
    <div class="tip">
      长按分享或保存图片
    </div>
    <div v-if="!url" class="info" id="reportCon">
      <div class="info-header">
        <div class="left">
          <div class="title">{{ rankLevel[form.level] }}</div>
          <div class="desc">再赚{{ form.nextLevelScore }}积分就能升级为{{ rankLevel[form.level] }}</div>
        </div>
        <!-- <img class="right" :src="icons[form.level - 1]" /> -->
      </div>
      <div class="main-page">
        <div :class="item == form.level ? 'swiper-item cur-leval' : 'swiper-item'" v-for="item in levalImg"
          data-item="item" :key="item">
          <img v-if="form.level < item" class="img" :src="d_icons[item - 1]" />
          <img v-else class='img' :src="icons[item - 1] || ''" />
        </div>

      </div>
      <div class="info-body">
        <div class="main">
          <div>
            <div v-if="form.level!=1" class="form-user">
              <div class="item">--</div>
              <div class="item" style="width: 42%;text-align: left;display: flex;align-items: center;">
                <img mode="aspectFit" class="user-header" src="../assets/images/user.png" />
                {{ form.name }}
              </div>
              <div class="item score">{{ form.pointsScore }}</div>
            </div>
            <div class="allScore">
              <div class="item">排名</div>
              <div class="item" style="width: 42%;text-align: left;">姓名</div>
              <div class="item">周积分</div>
            </div>
            <div :class="form.patientId==item.patientId?'allScore score-list current':'allScore score-list' " v-for="(item, index) in patients" data-item="item" data-index="index"
              :key="item.id">
              <div class="item">
                <div class="level-item" v-if="index == 0">
                  <img class="rankingNumberImg" src="../assets/rank/jin.png" />
                </div>
                <div class="level-item" v-else-if="index == 1">
                  <img class="rankingNumberImg" src="../assets/rank/yin.png" />
                </div>
                <div class="level-item" v-else-if="index == 2">
                  <img class="rankingNumberImg" src="../assets/rank/tong.png" />
                </div>
                <div class="level-item" v-else>{{ index + 1 }}</div>
              </div>

              <div class="item" style="width: 42%;text-align: left;display: flex;align-items: center;">
                <img class="user-header" v-if="item.url != '' && item.url != null" :src="item.url" />
                <img v-else mode="aspectFit" class="user-header" src="../assets/images/user.png" />
                {{ item.name }}
              </div>
              <div class="item score">{{ item.pointsScore }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="img-box">
      <img :src="url" />
    </div>
  </div>
</template>

<script>
import ajax from '../api/ajax';
import { getQueryString } from '../api/restapi';
import { htmlToPDF } from "../utils/html2pdf";
import icon_1 from "../assets/sqrank/leval-1.png";
import icon_2 from "../assets/sqrank/leval-2.png";
import icon_3 from "../assets/sqrank/leval-3.png";
import icon_4 from "../assets/sqrank/leval-4.png";
import icon_5 from "../assets/sqrank/leval-5.png";
import icon_6 from "../assets/sqrank/leval-6.png";
import icon_7 from "../assets/sqrank/leval-7.png";
import icon_8 from "../assets/sqrank/leval-8.png";
import icon_9 from "../assets/sqrank/leval-9.png";
import icon_10 from "../assets/sqrank/leval-10.png";
import d_icon_2 from "../assets/sqrank/d-leval-2.png";
import d_icon_3 from "../assets/sqrank/d-leval-3.png";
import d_icon_4 from "../assets/sqrank/d-leval-4.png";
import d_icon_5 from "../assets/sqrank/d-leval-5.png";
import d_icon_6 from "../assets/sqrank/d-leval-6.png";
import d_icon_7 from "../assets/sqrank/d-leval-7.png";
import d_icon_8 from "../assets/sqrank/d-leval-8.png";
import d_icon_9 from "../assets/sqrank/d-leval-9.png";
import d_icon_10 from "../assets/sqrank/d-leval-10.png";

// 排行榜等级
const rankLevel = ["新手上路", "健康小兵", "活力先锋", "养生达人", "健康卫士", "长寿大师", "智慧药师", "生命导师", "健康领袖", "长寿之星"]
export default {
  data() {
    return {
      levalImg: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      rankLevel,
      url: false,
      form: {},
      icons: [icon_1, icon_2, icon_3, icon_4, icon_5, icon_6, icon_7, icon_8, icon_9, icon_10],
      d_icons: [icon_1, d_icon_2, d_icon_3, d_icon_4, d_icon_5, d_icon_6, d_icon_7, d_icon_8, d_icon_9, d_icon_10],
      patients: []
    };
  },
  mounted() {
    console.log("mounted")
    document.title = '学习排行榜'
    this.id = getQueryString('id');

    this.getList();
  },

  methods: {
    getList() {
      ajax
        .Post({
          url: '/api/loss/communityCheckedInfo/selectStudyRankingList',
          data: { patientId: this.id }
        }).then(({ data: { success, data } }) => {
          if (success) {
            if (data.rankingList != null) {
              for (var i = 0; i < data.rankingList.length; i++) {
                data.rankingList[i].name = this.hideName(data.rankingList[i].name)
              }
              // let list=new Array(15).fill(data.rankingList[0])
              this.patients = data.rankingList.slice(0, 15)
            }
            let level = data.myInfo.level;
            if (data.myInfo != null) {
              this.form = {
                ...data.myInfo,
                level
              };
              if (level == 1) {
                this.levalImg = ['', ''].concat(this.levalImg.splice(level - 1, level + 2))
              } else if (level == 2) {
                this.levalImg = [''].concat(this.levalImg.splice(level - 2, level + 3))
              } else {
                this.levalImg = this.levalImg.splice(level - 3, level + 2)
              }
            }
            console.log("this.levalImg", this.levalImg)
            setTimeout(() => {
              this.saveImg()
            }, 500);
          }
        })
    },

    hideName(name) {
      if (name.length <= 1) {
        return name;
      }
      const surname = name.charAt(0);
      const hiddenPart = '*'.repeat(name.length - 1);
      return surname + hiddenPart;
    },
    saveImg() {
      htmlToPDF('reportCon').then(url => {
        this.url = url
      });
    },

  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.page-main {
  width: 100%;
  height: auto;
}

.info {
  width: 100%;
  height: auto;
  background-color: #fff;
  padding-bottom: 15px;
}

.info-header {
  height: 80px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-header .left {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.info-header .left .title {
  font-weight: 500;
  font-size: 24px;
  color: #333333;
}

.info-header .left .desc {
  font-size: 12px;
  color: #666666;
}

.info-header .right {
  width: 80px;
  height: auto;
}

.info-body {
  height: calc(100% - 158px);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(8px);
  padding:0 16px;
}

.main {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 8px;
  /* 垂直方向滚动条自动显示 */
  border-top: 1px solid #efefef;
}

.user-header {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 5px;
}

.rankingNumberImg {
  width: 32px;
  height: 20px;
}

.allScore {
  height: 44px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  color: #A1A3A5;
}

.item {
  text-align: center;
  flex: 1;
  font-size: 12px;
  min-width: 40px;
}

.level-item {
  display: flex;
  justify-content: center;

}

.score-list {
  color:#333;
  font-size: 16px;
  height: 56px;
  border-radius: 6px;
}
.current{
  color: #fff;
  background-color: #FBB13D;
}
.score{
  font-weight: 500;
}
.filter-time-box {
  margin-top: 15px;
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  margin-bottom: 30px;
  font-size: 14px;
  align-items: center;
}

.filter-time-box-text {
  margin-right: 15px;
}

.filter-time-box>view .init-text {
  color: #999;
}

.filter-time-box-time {
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  width: 197px;
  height: 32px;
  display: flex;
  align-items: center;
  padding-left: 80px;
}

.time-span {
  display: inline-block;
  margin-left: 8px;
  margin-right: 8px;
}

.item-css {
  border-bottom: 1px solid #A1A3A5;
  padding-bottom: 3px;
  margin-bottom: 3px;
}

.cur-user {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  gap: 5px;
  background-color: #fff;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);
}

.cur-user .header {
  width: 40px;
  height: 40px;
}

.cur-user .cur-user-con {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cur-user .cur-user-con .user-name {
  font-size: 16px;
  color: #333333;
}

.cur-user .cur-user-con .user-desc {
  font-size: 12px;
  color: #666;
}

.cur-user .user-sort {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}

.main-page {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.main-page .swiper-item {
  width: 48px;
  height: 100%;
  display: flex;
  align-items: center;
}

.main-page .cur-leval {
  width: 80px;
  height: 100%;
}

.main-page .swiper-item img {
  width: 100%;
  height: auto;
}
.form-user{
  width: 100%;
  height: 50px;
  font-size: 16px;
  color:#fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 6px;
  background-color:#FBB13D;
}
.img-box {
  width: 100%;
  height: auto;
}

.img-box img {
  width: 100%;
  height: auto;
}

.tip {
  color: #777;
  color: #FE5B59;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  padding: 20px 0;
}
</style>
